<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-3">
        <div class="card">
          <div class="card-body card-body-child">
            <div class="header bg-red header-child">
                <p>{{$t('CHILDDETAILS')}}</p>
                <div class="buttons">
                  <button type="button" class="btn button-edit mr-lg"  @click="showModal(child)">{{$t('EDIT')}}</button>
                  <button type="button" class="btn button-add"  @click="showResultAndOpinion(child)">{{$t('RESULTANDOPINION')}}</button>
                </div>
            </div>
            <div class="body body-child">
               <h2>{{child.name}} {{child.surname}}</h2>
                <p><b>{{$t('BIRTHDATE')}}:</b> {{moment(child.birthDate).format('DD.MM.YYYY')}}</p>
                <template v-for="item in child.parents">
                  <p :key="item.parentsId"><b>{{$t('PARENT')}}:</b><a @click="editParentData(item)"> {{item.name}} {{item.surname}} </a></p>
                </template>
                <p><b>{{$t('EDUCATOR')}}:</b> {{child.educatorName}} {{child.educatorSurname}}</p>
                <p><b>{{$t('EDUCATIONALGROUP')}}:</b> {{child.educationalGroupName}}</p>
                <p><b>{{$t('OBJECTNAME')}}:</b> {{child.objectName}}</p>
                <p><b>{{$t('CHRONOLOGICALAGE')}}:</b></p>
                <p>{{child.chronologicalAge}}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="card">
          <div class="card-body">
            <div class="body body-child-note">
                <p><b>{{$t('NOTE')}}:</b> {{child.note}}</p>
            </div>
            <div class="text-right">
                <button type="button" class="btn button-edit"  @click="editData('note', child)">{{$t('EDIT')}}</button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="card">
          <div class="card-body">
            <b-tabs>
              <b-tab :title="$t('ANAMNESTICFORM')">
                <div class="d-block" v-html="child.anamnestic"></div>
                <div class="text-right">
                  <b-btn class="mt-3 btn button-edit" @click="editData('anamnestic', child)">{{$t('EDIT')}}</b-btn>
                </div>
              </b-tab>
              <b-tab :title="$t('COMMUNICATIONFORM')">
                <div class="d-block" v-html="child.communication"></div>
                <div class="text-right">
                  <b-btn class="mt-3 btn button-edit" @click="editData('communication', child)">{{$t('EDIT')}}</b-btn>
                </div>
              </b-tab>
              <b-tab :title="$t('INSTRUMENTFORM')">
                <div class="d-block" v-html="child.instrument"></div>
                <div class="text-right">
                  <b-btn class="mt-3 btn button-edit" @click="editData('instrument', child)">{{$t('EDIT')}}</b-btn>
                </div>
              </b-tab>
              <b-tab :title="$t('OPINIONFORM')">
                <div class="d-block" v-html="child.opinion" justified></div>
                <div class="text-right">
                  <b-btn class="mt-3 btn button-edit" @click="editData('opinion', child)">{{$t('EDIT')}}</b-btn>
                </div>
              </b-tab>
              <b-tab :title="$t('DIAGNOSEFORM')">
                <div class="d-block" v-html="child.diagnoseName" justified></div>
                <div class="text-right">
                  <b-btn class="mt-3 btn button-edit" @click="editData('diagnose', child)">{{$t('EDIT')}}</b-btn>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-tabs>
                <arrivalrecordwin v-bind:childKindergartenId="$route.params.childKindergartenId"></arrivalrecordwin>
                  <documentwin v-bind:childKindergartenId="$route.params.childKindergartenId"></documentwin>
                <b-tab :title="$t('WORKPLANNERWIN')">
                  <workplannerwin v-bind:childKindergartenId="$route.params.childKindergartenId"></workplannerwin>
                </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <!-- CHILD FORM -->
    <b-modal ref="formmodal" :title="$t('CHILDFORM')" ok-title="submit" hide-footer size="xl" no-close-on-backdrop>
      <div class="d-block">
        <childform v-bind:formData="formData" v-bind:formError="formError"></childform>
      </div>
      <div class="text-right">
        <b-btn class="btn button-cancel mr-2" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="btn button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
      </div>
    </b-modal>
    <!-- CHILD DETAILS FORM -->
    <b-modal ref="formdetailmodal" :title="$t('CHILDDETAILSFORM')" ok-title="submit" hide-footer size="xl" no-close-on-backdrop>
      <div class="d-block">
        <childdetailsform v-bind:formData="formData" v-bind:formError="formError"></childdetailsform>
      </div>
      <div class="text-right">
        <b-btn class="btn button-cancel mr-2" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="btn button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
      </div>
    </b-modal>
    <!-- PARENT FORM -->
    <b-modal ref="formparentmodal" :title="$t('CHILDDETAILSFORM')" ok-title="submit" hide-footer size="xl" no-close-on-backdrop>
      <div class="d-block">
        <parentform v-bind:formData="parent" v-bind:formError="formError"></parentform>
      </div>
      <div class="text-right">
        <b-btn class="btn button-cancel mr-2" @click="hideModalParent()">{{$t('CANCEL')}}</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import Api from '@/api/child_kindergarten/ChildKindergarten';
import ChildForm from './Form.vue';
import ChildDetailsForm from './FormDetail.vue';
import ParentForm from './ParentForm.vue';
import DocumentWin from './documents/DocumentsWin.vue';
import ArrivalRecordWin from './arrivalrecord/ArrivalRecordWin.vue';
import WorkPlannerWin from './workplanner/WorkPlannerWin.vue';

export default
{
    name: 'TherapyType',
    components:
  {
      childform: ChildForm,
      childdetailsform: ChildDetailsForm,
      arrivalrecordwin: ArrivalRecordWin,
      workplannerwin: WorkPlannerWin,
      documentwin: DocumentWin,
      parentform: ParentForm,
  },
    data()
    {
        return {
            child: {},
            formError:
      {},
            formData:
      {
          name: '',
          surname: '',
          birthDate: null,
          parentId: null,
          educationalGroupId: null,
          objectNameId: null,
          note: '',
          anamnestic: '',
          communication: '',
          instrument: '',
          opinion: '',
          diagnoseId: null,
      },
            parent: {},
        };
    },
    created()
    {
        const me = this;
        me.getData();
    },
    methods:
  {
      async getData()
      {
          const me = this;
          try
          {
              const data = await Api.selectSingleRow({ childKindergartenId: me.$route.params.childKindergartenId });
              if (data.error && data.error === true)
              {
                  me.$notify.notice(data);
                  me.loading = false;
                  return;
              }

              me.child = data.root;
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      showModal(item)
      {
          const me = this;
          if (typeof item !== 'undefined')
          {
              me.formData = item;
          }
          this.$refs.formmodal.show();
      },
      async submitData(item)
      {
          const me = this;
          try
          {
              if (typeof item.childKindergartenId !== 'undefined')
              {
                  item.id = item.childKindergartenId;
                  delete (item.childKindergartenId);
                  delete (item.key);
              }

              if (item.parents != null)
              {
                  delete (item.parents);
              }

              if (item.birthDate !== undefined)
              {
                  item.birthDate = moment(item.birthDate).format('YYYY-MM-DD');
              }

              const data = await Api.submitData(item);
              if (data.error)
              {
                  me.$notify.notice(data);
                  me.formError = data;
              }
              else
              {
                  me.$notify.notice(data);
                  me.hideModal();
                  await me.getData();
              }
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      hideModal()
      {
          const me = this;
          this.$refs.formmodal.hide();
          this.$refs.formdetailmodal.hide();

          me.formData = {
              name: '',
              surname: '',
              parentId: null,
              educationalGroupId: null,
              objectNameId: null,
              note: '',
              anamnestic: '',
              communication: '',
              instrument: '',
              opinion: '',
          };
      },
      editData(key, value)
      {
          const me = this;
          me.formData = value;
          me.$set(me.formData, 'key', key);
          me.$refs.formdetailmodal.show();
      },
      async showResultAndOpinion()
      {
          const me = this;
          try
          {
              await Api.printToPdf({ childKindergartenId: me.$route.params.childKindergartenId });
          }
          catch (e)
          {
              me.$notify.notice(e);
          }
      },
      async editParentData(item)
      {
          const me = this;
          try
          {
              me.parent = item;
              me.$refs.formparentmodal.show();
          }
          catch (error)
          {
              me.$notify.notice(error);
          }
      },
      hideModalParent()
      {
          const me = this;
          me.$refs.formparentmodal.hide();
      },
  },
    watch:
  {

  },
    computed:
  {

  },
};
</script>
